import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {HttpParams} from '@angular/common/http';
import { AuthService } from '../../core/auth.service';
import { BaseService } from '../../shared/base.service';
import { UsersService } from '../../users/users.service';
import { HomeService } from '../home.service';
import { AppService } from '../../app.service';
import { UserModel } from '../../users/user.model';
import { HomeComponent } from '../home.component';
import { ClinicsService } from '../../clinics/clinics.service';
import { UsersComponent } from '../../users/users.component';
import { TranslateService } from '@ngx-translate/core';
import { IMyDateModel, IMyDpOptions, IMyInputFieldChanged, IMyInputFocusBlur } from 'mydatepicker';
import * as moment from 'moment';

@Component({
    selector: 'insurance-partner-component',
    templateUrl: './insurance-partner.component.html',
    styleUrls: ['./insurance-partner.component.scss'],
    providers: [UsersService, BaseService, HomeService, ClinicsService]
})

export class InsurancePartnerComponent extends HomeComponent implements OnInit {

    @ViewChild('usersComponent', { static: false }) usersComponent: UsersComponent;

    clinicUsers: Object[] = [];
    isHome = true;
    years = [moment().year()];
    months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    dateFormat: string = 'YYYY-MM-DD';
    dateOptionFilter = {
        from: moment().format("MM-DD-YYYY"),
        to: moment().format("MM-DD-YYYY")
    };
    isFiltered = false;
    today = moment();
    filterType = {
          TIME: 'time',
          MONTH: 'month',
          YEAR: 'year',
          AGE: 'age',
          ALL: 'all'
    };
    filterParams = {
        type: this.filterType.TIME,
        month: 0,
        year: moment().year(),
        startDate: this.today.day(-30).format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        startAge: 0,
        endAge: 999,
        gender: 0
    };
    filterByMonth: number;
    filterByYear: number;
    readonly dateRangeOptions = [
        {
            type: '30DAYS',
            name: 'Last 30 days',
            value: 0
        },
        {
            type: '7DAYS',
            name: 'Last 7 days',
            value: 1
        },
        {
            type: 'MONTH',
            name: 'Pick month',
            value: 2
        },
        {
            type: 'YEAR',
            name: 'Pick year',
            value: 3
        }
    ];
    filterTime = this.dateRangeOptions[0];
    exportData = false;

    /**
     *
     * @param authService
     * @param router
     * @param translate
     * @param baseService
     * @param appService
     * @param usersService
     * @param homeService
     */
    constructor(public authService: AuthService,
                public router: Router,
                public translate: TranslateService,
                public baseService: BaseService,
                public appService: AppService,
                public usersService: UsersService,
                public homeService: HomeService) {
        super(authService, router, translate, baseService, appService, usersService);
    }

    /**
     * Component Init
     */
    ngOnInit() {
        super.ngOnInit();
        this.searchInfo = new UserModel();
        this.url = 'home';
        const currentYear = moment().year();
        for(let i = 1; i<=10; i++){
            let preYear = currentYear - i;
            this.years.push(preYear);
        }
        this.setDateRange();
    }

    setDateRange(){
        this.today = moment();
        let year = this.filterParams.year || this.years[0];
        let month = this.filterParams.month || 0;
        let endMonth = moment().month();
        let startDate = moment([year, month]).startOf('month').format(this.dateFormat);
        let endDate = moment([year, endMonth]).endOf('month').format(this.dateFormat);
        switch (this.filterTime['type']) {
            case 'YEAR':
                startDate = moment([year]).startOf('year').format(this.dateFormat);
                endDate = moment([year]).endOf('year').format(this.dateFormat);
                break;

            case 'MONTH':
                startDate = moment([year, month]).startOf('month').format(this.dateFormat);
                endDate = moment([year, month]).endOf('month').format(this.dateFormat);
                break;

            case '7DAYS':
                startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                endDate = moment().format('YYYY-MM-DD');
                break;

            default:
                // 30 days
                startDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
                endDate = moment().format('YYYY-MM-DD');
                break;
        }
        this.filterParams.startDate = startDate;
        this.filterParams.endDate = endDate;
        return this.setFilters();
    }

    setFilterParams(params: any){
        if(!params){
            return this.setFilters();
        }
        for(let index in params){
            let param = params[index];
            this.filterParams[param['key']]  = param['value'];
        }
        return this.setFilters();
    }

    setFilters(): string {
        let filters = '';
        let isFirstFilter = true;
        for (const key in this.filterParams) {
            if (isFirstFilter) {
                isFirstFilter = false;
            } else {
                filters += '&';
            }
            filters += key + '=' + this.filterParams[key];
        }

        this.filters = filters;
        return this.filters;
    }

    export() {
        this.exportData = true;
        let _self = this;
        setTimeout(function(){
            const form = <HTMLFormElement>document.getElementById('frmExport');
            const token = _self.authService.user['token'];
            form.action = form.action + '?token=' + token;
            form.action += '&startDate=' + _self.filterParams.startDate;
            form.action += '&endDate=' + _self.filterParams.endDate;
            form.action += '&lang=' + _self.translate.currentLang;
            form.action += '&gender=' + _self.filterParams.gender;
            form.action += '&startAge=' + _self.filterParams.startAge;
            form.action += '&endAge=' + _self.filterParams.endAge;
            form.submit();
            _self.exportData = false;
        }, 500);

    }
}
